import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {CSVLink} from 'react-csv';
import LocationInventoryLevelsSearchFilter from '../components/LocationInventoryLevelsSearchFilter';
import LocationInventoryLevelsTable from '../components/LocationInventoryLevelsTable';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import Icon from 'material-ui/svg-icons/action/assignment';

export class LocationInventoryLevels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            dataListHeaders: [
                {label: 'Location ID', key: 'location_id'},
                {label: 'Location Name', key: 'location_name'},
                {label: 'Zero Day', key: 'current_zero_day'},
                {label: 'Active', key: 'location_active_str'}

            ],
            dataListHeadersWithProduct: [
                {label: 'Product ID', key: 'product_id'},
                {label: 'Product Name', key: 'product_name'}
            ],
            dataListHeadersNonZero: [
                {label: 'Pieces', key: 'pieces'}
            ],
            filterSubmitted: false,
            filterValues: {
                includeProduct: false,
                searchName: '',
                sign: ''
            },
            listComplete: false,
            loading: false
        };
    }

    handleFilterSubmit = (obj) => {
        const includeProduct = !!(obj && obj.includeProduct);
        const searchName = (obj && obj.searchName) ? obj.searchName : '';
        const sign = (obj && obj.sign) ? obj.sign : '';
        if (sign && ((includeProduct && includeProduct) || (!includeProduct))) {
            this.setState({
                filterSubmitted: true,
                filterValues: {
                    includeProduct: includeProduct,
                    searchName: searchName,
                    sign: sign
                },
                loading: true,
                listComplete: false
            });
        }
    };

    handleListComplete = (isComplete, data) => {
        this.setState({
            dataList: data,
            listComplete: isComplete,
            loading: false
        });
    };

    assembleTitle = (fv) => {
        let title = 'Location';
        if (fv.sign === 'positive') {
            title += '-Positive';
        }
        if (fv.sign === 'negative') {
            title += '-Negative';
        }
        if (fv.sign === 'zero') {
            title += '-Zero';
        }
        title += '-Inventory-Levels';
        if (fv.includeProduct) {
            title += '-with-Product';
        }
        return title;
    };

    assembleText = (fv) => {
        let text = {
            loading: 'Searching Locations',
            title: 'Locations with'
        };
        if (fv.sign === 'positive') {
            text.title += ' positive';
        }
        if (fv.sign === 'negative') {
            text.title += ' negative';
        }
        if (fv.sign === 'zero') {
            text.title += ' zero';
        }
        text.title += ' inventory levels';
        if (fv.searchName && fv.searchName !== '') {
            text.loading += ' with "' + fv.searchName + '"';
            text.title += ' containing "' + fv.searchName + '"';
        }
        return text;
    };

    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {
        const {
            dataList,
            dataListHeaders,
            dataListHeadersWithProduct,
            dataListHeadersNonZero,
            filterSubmitted,
            filterValues,
            listComplete,
            loading
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Location Inventory Levels</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>Search all Locations with positive, negative, or zero inventory.</p>
                    <p>Optionally, enter a Product Name to search Locations with positive, negative, or
                        zero inventory levels with that Product.</p>
                </span>
            );
        };

        let title = this.assembleTitle(filterValues);
        const text = this.assembleText(filterValues);

        let csvHeaders = [...dataListHeaders];
        if (filterValues.includeProduct) {
            csvHeaders = [...csvHeaders, ...dataListHeadersWithProduct];
        }
        if (filterValues.sign !== '' && filterValues.sign !== 'zero') {
            csvHeaders = [...csvHeaders, ...dataListHeadersNonZero];
        }

        return (
            <div className="list-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        <LocationInventoryLevelsSearchFilter
                            loading={loading}
                            onSubmitFilter={this.handleFilterSubmit}
                        />

                        {filterSubmitted &&
                            <div>
                                {(loading || listComplete) &&
                                    <div className="report-header">
                                        <h3>{text.title}</h3>
                                        {listComplete &&
                                            <FlatButton
                                                primary
                                                type="button"
                                                label=""
                                                style={viewStyles.headerButton}
                                            >
                                                <ExportIcon style={viewStyles.headerButtonIcon} />
                                                <CSVLink
                                                    data={dataList}
                                                    headers={csvHeaders}
                                                    filename={`${title}`}
                                                    onClick={(e) => this.handleExportClick(e)}
                                                    target="_blank"
                                                    style={viewStyles.headerButtonLink}
                                                >
                                                    Export CSV
                                                </CSVLink>
                                            </FlatButton>
                                        }
                                    </div>
                                }

                                {loading && !listComplete &&
                                    <div className="loader-container">
                                        <h4>{text.loading}...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    </div>
                                }

                                <LocationInventoryLevelsTable
                                    filterValues={filterValues}
                                    listComplete={listComplete}
                                    onDataComplete={this.handleListComplete}
                                />

                            </div>
                        }

                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/LocationInventoryLevels.js